import { Location as LocationCommon } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { LocationService } from '@services/location.service';
import { I18nService } from '@services/i18n.service';
import { NavigationStore } from '@services/navigation.store';
import { HeaderActionsComponent } from '../../shared/header-actions/header-actions.component';

@Component({
  selector: 'app-top-navigation',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzIconModule, NzFlexModule, NzTypographyModule, HeaderActionsComponent],
  templateUrl: './top-navigation.component.html',
  styleUrl: './top-navigation.component.less',
})
export class TopNavigationComponent {
  @Input() title: string = '';
  @Input() showBackButton: boolean = true;

  constructor(
    private locationCommon: LocationCommon,
    private router: Router,
    private locationService: LocationService,
    private i18nService: I18nService,
    private navigationStore: NavigationStore,
  ) {}

  get backIcon(): string {
    return this.i18nService.isRtl ? 'arrow-right' : 'arrow-left';
  }

  onGoBack(): void {
    const backRedirectCommands = this.getBackRedirectCommands();

    if (backRedirectCommands) {
      void this.router.navigate(backRedirectCommands);
      return;
    }

    const navigationId = (window.history.state && window.history.state.navigationId) || 0;

    if (navigationId > 1) {
      this.locationCommon.back();
    } else {
      const location = this.locationService.getLocation();
      const locationUuid = location.uuid;
      this.router.navigate([locationUuid, 'services']);
    }
  }

  private getBackRedirectCommands(): (string | number)[] | null {
    const activeRoute = this.getDeepestRoute(this.router.routerState.snapshot.root);
    const storeBackRedirect = activeRoute.data?.['useNavigationStore'] === true
      ? this.navigationStore.getBackRedirect()
      : null;

    if (Array.isArray(storeBackRedirect)) {
      return storeBackRedirect;
    }

    const routeBackRedirect = activeRoute.data?.['backRedirect'] as readonly (string | number)[] | undefined;

    if (!Array.isArray(routeBackRedirect)) {
      return null;
    }

    const locationUuid = this.locationService.getLocation()?.uuid;

    if (!locationUuid) {
      return null;
    }

    return ['/', locationUuid, ...routeBackRedirect];
  }

  private getDeepestRoute(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    let currentRoute = route;

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }

    return currentRoute;
  }
}
